(function() { module.exports = window["Next"]["Breadcrumb"]; }());